export default {
  index: {
    theWordCountShallNotExceed: '字数不得超过{val1}个字',
  },
};
